export default __webpack_public_path__ + "static/small-image-yangol-4-bfcba19453f31d7cc6617ae13a648012.png";